export default {
  name: 'PublicityDetail',
  props: {
    publicityDetailConfig: Object
  }
};
